export default __webpack_public_path__ + "pl.svg?e14e076f0ca17a1ef3f5731060ad8ada";